/**
 * Header some ao rolar para baixo e reaparece ao rolar para cima (padrão desktop).
 * Em viewports < lg o header permanece fixo visível para não esconder o menu hamburger.
 */
function initAutoHideHeader() {
  const header = document.querySelector(".js-auto-hide-header");
  if (!header) {
    return;
  }

  const mqDesktop = window.matchMedia("(min-width: 992px)");
  let lastY = window.scrollY;
  let ticking = false;

  function update() {
    const y = window.scrollY;

    if (!mqDesktop.matches) {
      header.classList.remove("is-header-hidden");
    } else if (y < 16) {
      header.classList.remove("is-header-hidden");
    } else if (y > lastY && y > 72) {
      header.classList.add("is-header-hidden");
    } else if (y < lastY) {
      header.classList.remove("is-header-hidden");
    }

    lastY = y;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });

  mqDesktop.addEventListener("change", () => {
    header.classList.remove("is-header-hidden");
    lastY = window.scrollY;
  });
}

document.addEventListener("DOMContentLoaded", initAutoHideHeader);
